// src/Login.tsx
import React from "react";
import { Form, Input, Button, Card, message } from "antd";
import { useAppDispatch } from "../../app/hooks";
import { LoginResponse } from "../../features/login/types";
import { update } from "../../features/login/loginSlice";
import { Cookies } from "react-cookie";
import { errorNameToMessage } from "../../utils/ErrorMessages";
import { loading, notLoading } from "../../features/loading/loadingSlice";
import { fetchWithResponse } from "../../utils/EasyFetch";
import { Buffer } from "buffer";

const Login = () => {
  const dispatch = useAppDispatch();
  const [messageApi, contextHolder] = message.useMessage();

  const performLogin = (user: string, password: string) => {
    const cookies = new Cookies();
    dispatch(loading());
    fetchWithResponse<LoginResponse>(
      "POST",
      "/auth",
      undefined,
      "Basic " + Buffer.from(user + ":" + password).toString("base64")
    )
      .then((r: LoginResponse) => {
        dispatch(
          update({
            accessToken: r.accessToken,
            refreshToken: r.refreshToken,
            user: user,
          })
        );
        cookies.set("accessToken", r.accessToken, {
          path: "/",
          sameSite: true,
        });
        cookies.set("user", user, { path: "/", sameSite: true });
        cookies.set("refreshToken", r.refreshToken, {
          path: "/",
          sameSite: true,
        });
      })
      .catch((err: any) => {
        dispatch(notLoading());
        messageApi.open({
          type: "error",
          content: errorNameToMessage(err.name),
        });
      });
  };

  const onFinish = (values: any) => {
    performLogin(values.username, values.password);
  };

  return (
    <div>
      {contextHolder}
      <Card
        title="Login"
        style={{ width: 300, margin: "auto", marginTop: "100px" }}
      >
        <Form name="login" onFinish={onFinish}>
          <Form.Item
            name="username"
            rules={[{ required: true, message: "Please enter your username" }]}
          >
            <Input placeholder="Username" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please enter your password" }]}
          >
            <Input.Password placeholder="Password" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Log In
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
